import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BalanceCardComponent } from "./balance-card.component";

@NgModule({
  imports: [CommonModule],
  declarations: [BalanceCardComponent],
  exports: [BalanceCardComponent],
})
export class BalanceCardComponentModule {}
